import apiConnector from '@/epersonam/apiConnector';
import { Route } from '@/epersonam/route';
import { ReportTemplateService } from '@/epersonam/services/reportTemplateService';

export const print = {
  methods: {
    async PU_resolveRequirements(newRequirements, guest_period_data_set_id, serializer) {
      let response = await this.PU_addingDynamicDataToText(newRequirements, `${Route.REPORT_TEMPLATE}/translate_params.json`, {
        guest_period_id: guest_period_data_set_id,
      });
      response.data.map((el) => this.PU_mergeDatasIntoSerializer(el, serializer));
      return serializer;
    },
    async PU_translateVariablesAndResolve(
      serializer,
      texts,
      allRequirements,
      guest_period_data_set_id,
      newRequirements = allRequirements,
      showNotFound = true,
      avoidTag = false,
      replaceFunction = null,
    ) {
      this.loadBarCodeResource(texts);
      const newSerializer = await this.PU_resolveRequirements(newRequirements, guest_period_data_set_id, serializer);
      const rts = ReportTemplateService.substituteRequirementsV2(
        texts,
        allRequirements,
        newSerializer,
        avoidTag,
        replaceFunction,
        showNotFound,
      );
      return rts;
    },
    loadBarCodeResource(texts) {
      texts.forEach((el) => {
        if (el?.includes('bar_code_ncartella') && !window.JsBarcode) {
          let resources = [
            {
              name: 'js-barcode',
              path: Route.CDN_ACARE_JS_BARCODE,
              type: 'js',
            },
          ];

          this.adv_resources.loadResources(resources);
        }
      });
    },
    PU_mergeDatasIntoSerializer(result, serializer) {
      let model = serializer[result.model];
      let dataObject = {
        value: result.value ? result.value : null,
        style: result.print_conditions ? result.print_conditions.style : null,
        classes: result.print_conditions ? result.print_conditions.classes : null,
      };
      if (model) {
        model[result.key] = dataObject;
      } else {
        serializer[result.model] = {
          [result.key]: dataObject,
        };
      }
    },
    async PU_addingDynamicDataToText(requirements, url, params) {
      let modelWithMethod = requirements.filter((el) => el.requirements && el.requirements[0].method);
      let data = await apiConnector().post(url, { modelWithMethod, additionalParams: params });
      return data;
    },
    async printRequest(params, worker = 'CotWorker', isCot = true) {
      try {
        this.adv_common.openAdvLoader();
        let urlGenerateReport = `${isCot ? window.config.ePersonamService.apiCotHost : window.config.ePersonamService.ePersonamHost}/${window.locale}/reports/generate_report.json?&worker=${worker}`;
        await this.adv_common.apiConnector('POST').fetch(urlGenerateReport, { body: params });
        this.adv_common.closeAdvLoader();
      } catch (e) {
        this.adv_common.closeAdvLoader();
        console.error(e);
      }
    },
  },
};
